module.exports = __webpack_public_path__ + "static/media/photo.8a4f3b98.jpg";